import Vue from 'vue'
import Vuex from 'vuex'

const footers = {
    "default": {
        hidden: true
    },
    "normal": {
        hidden: false,
        buttons: [
            {
                title: '首页',
                route: {
                    path: '/home'
                }
            },
            {
                title: '活动',
                route: {
                    path: '/event'
                }
            },
            {
                title: '会员',
                route: {
                    path: '/user/member'
                }
            },
        ]
    }
}

const state = {
    resizeBar: false,
    footer: footers["default"]
}

// mutations
const mutations = {
    resizeBar(state) {
        state.resizeBar = !state.resizeBar;
    },
    footer(state, val) {
        if (!val || typeof(val)!='string' || !footers[val])  {
            val = "default"
        } 
        
        state.footer = footers[val]
    }
}

export default {
    namespaced: true,
    state,
    //    getters,
    //    actions,
    mutations
}